define([], function () {
	'use strict';

	/**
	 * PaswordBindingType class
	 * 
	 * @param secret
	 * @param salt
	 * @returns {PaswordBinding}
	 */
	return function (secret, type, salt) {

		var _type = "http://ws.skidentity.de/ci/binding/password/v1.0";
		var _secret = secret,
			_salt = salt;

		// public methods
		
		this.type = function () {
			return _type;
		};

		this.secret = function() {
			return _secret;
		};
	
		this.salt = function() {
			return _salt;
		};

		this.toObject = function () {
			return {
				type : this.type(),
				salt : _salt
			};
		};
		
		//Used for CID-issue (session-storage)
		this.toObjectWithSecret = function () {
			return {
				type : this.type(),
				secret: _secret,
				salt : _salt
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/bindings/PasswordBindingType.js
// module id = 74
// module chunks = 3